import type { CSSProperties, FC, ReactNode } from 'react';

// `display: contents` keeps the host out of `ps-page`'s grid, so the overlay
// lays out exactly as it did as a direct child.
const overlayHostStyle: CSSProperties = { display: 'contents' };

/**
 * The part of `Root` (router.tsx) that sits between the primary nav and the
 * toast container: the routed page, then the app-wide overlays.
 *
 * The overlay is wrapped in an element React owns (PSTUDIO-4287). An open
 * `ps-modal` moves itself into a portal (`ModalWC._openModal`) and returns
 * only after its close transition (`ModalWC._closeModal`). A route change
 * inserts the new page with `insertBefore(<next host sibling>)`, and without
 * this host that sibling was the relocated modal, which throws. The host
 * itself never moves, and the modal re-appends into it on close because
 * `parentEl` is recorded in `ModalWC.firstUpdated`.
 *
 * The routed page is NOT wrapped: `PageWC.handleSlotChange` detects the
 * sidebar and side-nav among the DIRECT children of `ps-page`'s default slot.
 */
export const RootBody: FC<{ main: ReactNode; overlay: ReactNode }> = ({
  main,
  overlay,
}) => (
  <>
    {main}
    <div data-root-overlay-host="" style={overlayHostStyle}>
      {overlay}
    </div>
  </>
);
